import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import nexapi from '../../services/api';
import { notify } from '../../components/UI/notify';
import { NotifyType } from '../../types/enums/notifytype';

import {RequestStatus} from '../slices/commonEnum';
import { ArchivalModal } from '../../types/models/ArchivalModal';

interface CompanyState {
  data: ArchivalModal[];
  totalRecords: number;
  currentPage: number;
  loading: boolean;
  error: string | null;
  status: string | null;
}

interface CompanyResponse {
  Jobs: ArchivalModal[];
  totalCount: number;
}

const initialState: CompanyState = {
  data: [],
  totalRecords: 0,
  currentPage: 0,
  loading: false,
  error: null,
  status: 'idle',
};

const API_URL = '/RequestForm';
const { message } = notify();

// Async thunk for fetching requests
export const fetchJobsLogs= createAsyncThunk<CompanyResponse, { 
  filters: Record<string, any>;
  page: number; 
  numberOfRecord: number;
  userId: string;
  sortColumn: string;
  sortOrder: 'asc' | 'desc';
}>(
  'RequestForm/fetchJobsLogs',
  async ({filters, page, numberOfRecord, userId, sortColumn = '', sortOrder = 'asc' }) => {
    try {
      const response = await nexapi.post(API_URL + `/GetArchivedLogs?pagination=true&page=${page}&numberOfRecord=${numberOfRecord}&search=${filters.search}&userTimeZone=${filters.userTimeZone}&sortColumn=${sortColumn}&sortOrder=${sortOrder}`);
      const data = response.data;

      if (Array.isArray(data?.data)) {
        //console.log("Job Logs Data: ", data?.data);
        //console.log("Job Logs Data Count: ", data?.totalCount);
        return {
          Jobs: data.data as ArchivalModal[], // Cast to SubtypeModel[]
          totalCount: data.totalCount,
        };
      } else {
        console.error("Invalid API Response:", data);
        return { Jobs: [], totalCount: 0 };
      }
    } catch (error) {
      console.error("API Call Failed:", error);
      return { Jobs: [], totalCount: 0 };
    }
  }
);

//#region Function to check if the company code is unique

//#endregion






const requestsSlice = createSlice({
  name: 'Jobs',
  initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchJobsLogs.fulfilled, (state, action) => {
          // Assuming action.payload contains applications and totalCount
          state.data = action.payload.Jobs;
          state.totalRecords = action.payload.totalCount;
          state.status = RequestStatus.SUCCEEDED;
        })
        .addMatcher(
          (action) => action.type.endsWith('/pending'),
          (state) => {
            state.status = RequestStatus.LOADING;
          }
        )
        .addMatcher(
          (action) => action.type.endsWith('/rejected'),
          (state, action) => {
            state.status = RequestStatus.FAILED;       
          }
        );
    },
});

export default requestsSlice.reducer;
